const SupportUser = () => {
  return <div>Coming soon</div>;
};

export default SupportUser;
